import { NextPage } from 'next';
import React from 'react';
import { Header } from 'components/structures';
import DetailPage from '../../containers/expertise/DetailPage';
import { powerDeliveryHero, powerInfrastructureSolutions } from '../../images/expertise/power-delivery';

const PowerDelivery: NextPage = () => {
  return (
    <>
      <Header
        title="Power Delivery"
        description="We provide comprehensive power delivery services for overhead and underground infrastructure, ensuring efficient, reliable, and safe utility construction across urban and rural areas."
        image={powerDeliveryHero}
      />
      <DetailPage
        listBlocks={[
          {
            bgImage: powerInfrastructureSolutions,
            id: 'powerInfrastructureSolutions',
            hasListItems: true,
            title: 'End-to-End Power Infrastructure Solutions',
            listItems: [
              {
                boldText: 'Overhead Power Distribution:',
                text: 'Installation and maintenance of power lines, poles, and conductor replacements',
              },
              {
                boldText: 'Transmission Line Construction:',
                text: 'High-voltage transmission lines for power distribution across long distances',
              },
              {
                boldText: 'Substation Construction & Upgrades:',
                text: 'Design, construction, and modernization of substations for optimized grid performance',
              },
              {
                boldText: 'Underground Power Solutions:',
                text: 'Directional drilling, duct banks, conduit, and cable installations',
              },
              { boldText: 'Storm Restoration:', text: 'Rapid-response teams for power restoration and storm-damage repair' },
              {
                boldText: 'Grid Compliance & Safety:',
                text: 'Regulatory adherence, environmental compliance, and rigorous safety protocols',
              },
              {
                boldText: 'Engineering & Design Support:',
                text: 'Full project planning, structural engineering, and customized layouts',
              },
            ],
          },
        ]}
      />
    </>
  );
};

export default PowerDelivery;
